import React, { useState, useRef } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Home() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/home";

  const features = [
    {
      icon: "/assets/iconOne.png",
      title: t("RealProfile"),
      description: t("RealProfileDesc"),
    },
    {
      icon: "/assets/iconTwo.png",
      title: t("InstantMeetingOpportunity"),
      description: t("InstantMeetingOpportunityDesc"),
    },
    {
      icon: "/assets/iconThree.png",
      title: t("VenueChats"),
      description: t("VenueChatsDesc"),
    },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-[#FDECEE]">
      {/* Header */}
      <Header isHomePage={true} />
      {/* Hero Section */}
      <section className="bg-[#FCB8C4] flex flex-col items-center justify-center pt-20 md:pt-20">
        <div className="w-full lg:max-w-[900px] mx-auto flex justify-center items-center">
          <video
            src="/assets/qriendhome.webm"
            className="w-full h-auto rounded-2xl  "
            autoPlay
            {...(isHome ? { loop: true } : {})}
            muted
            playsInline
            poster="/assets/landıngo2.png"
          />
        </div>
      </section>

      {/* What is QRiend Section - Modern Tasarım */}
      <section className="w-full bg-[#FFF3F6] py-16 px-4 flex flex-col items-center">
        <div className="max-w-6xl w-full flex flex-col items-center">
          <div className="flex items-center justify-center mb-6 gap-3 pt-4">
            <h2 className="text-[#2F327D] text-3xl md:text-[42px] font-bold font-poppins text-center m-0">
              {t("WhatIsQriend")}
            </h2>
          </div>
          <p className="text-[#696984] text-lg md:text-[21px] font-poppins mb-14 text-center max-w-[750px] ">
            {t("WhatIsQriendDesc")}
          </p>
          <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-center bg-gradient-to-br from-[#FFF3F6] to-white rounded-2xl shadow-lg p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl group"
              >
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-white flex items-center justify-center mr-6 border-2 border-[#FFBDC6]">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-full h-full object-cover pt-2"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-col justify-center items-start">
                  <h3 className="text-[#2F327D] font-bold text-lg md:text-xl font-poppins mb-2 group-hover:text-pink-400 transition text-left">
                    {feature.title}
                  </h3>
                  <p className=" text-black font-poppins text-left text-lg sm:text-sm md:text-base">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <img
            src="/assets/qriendPhoneTanitim.png"
            alt="QRiend telefon tanıtım"
            className="w-full max-w-2xl h-auto rounded-3xl object-contain pt-4"
            loading="lazy"
          />
        </div>
      </section>
      {/* How to meet section */}
      <section className="bg-white py-12 sm:py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-8 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center">
            <div className="relative order-1 md:order-1">
              <div className="relative max-w-2xl mx-auto md:mx-0">
                {" "}
                <div className="relative z-10">
                  <div
                    className="
          overflow-hidden relative w-full
          max-w-[400px] sm:max-w-[600px] md:max-w-[900px] lg:max-w-[1200px]
          mx-auto md:mx-0
        "
                  >
                    <img
                      src="/assets/nasilTanisilir.png"
                      alt="Telefon kullanan kadın"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Sağ taraf - Başlık ve açıklamalar */}
            <div className="text-left order-2 md:order-2">
              <h2 className="text-3xl md:text-[42px] font-bold font-poppins text-[#242331] text-left mb-4">
                {t("HowtoMeet")}
              </h2>
              <p className="text-[#797979] text-left text-lg md:text-[21px] font-poppins mb-8 max-w-lg">
                {t("HowtoMeetDesc")}
              </p>

              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <img
                      src="/assets/verify.png"
                      alt="Tik işareti"
                      className="w-6 h-6 md:w-8 md:h-8"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl md:text-2xl text-[#1D2939] mb-2">
                      {t("EntryandConnectiontotheSpace")}
                    </h3>
                    <ul className="text-[#1D2939]">
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("EntryandConnectiontotheSpaceDesc")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("EntryandConnectiontotheSpaceDesc2")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <img
                      src="/assets/verify.png"
                      alt="Tik işareti"
                      className="w-6 h-6 md:w-8 md:h-8"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl md:text-2xl text-[#1D2939] mb-2">
                      {t("InSituExploration")}
                    </h3>
                    <ul className="text-[#1D2939]">
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("InSituExplorationDesc")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("InSituExplorationDesc2")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <img
                      src="/assets/verify.png"
                      alt="Tik işareti"
                      className="w-6 h-6 md:w-8 md:h-8"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl md:text-2xl text-[#1D2939] mb-2">
                      {t("CommunicationInitiation")}
                    </h3>
                    <ul className="text-[#1D2939]">
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("CommunicationInitiationDesc")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("CommunicationInitiationDesc2")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("CommunicationInitiationDesc3")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <img
                      src="/assets/verify.png"
                      alt="Tik işareti"
                      className="w-6 h-6 md:w-8 md:h-8"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl md:text-2xl text-[#1D2939] mb-2">
                      {t("SafeSocialization")}
                    </h3>
                    <ul className="text-[#1D2939]">
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("SafeSocializationDesc")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("SafeSocializationDesc2")}
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-sm sm:text-base md:text-lg">
                          {t("SafeSocializationDesc3")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Download Section */}
      {/* <section className="container mx-auto px-4 py-8 sm:py-8 md:py-12 lg:py-20">
        <div className="max-w-[1182px] max-h-[493px] mx-auto relative">
          <div className="w-full overflow-hidden rounded-[20px] sm:rounded-[24px] md:rounded-[28px] lg:rounded-[32px]">
            <img
              src="/assets/mockupbgdw.png"
              alt="Premium İndir Arka Plan"
              className="w-full min-h-[200px] object-cover"
              loading="lazy"
            />
          </div>

          <div className="absolute inset-0 flex flex-col justify-center items-start p-4 sm:p-8 md:p-12 lg:p-16">
            <div className="sm:max-w-[300px] md:max-w-[420px] lg:max-w-[482px] p-2 sm:py-16 md:py-12 mt-[6px] sm:mt-20 text-left">
              <h2 className="sm:text-base md:text-3xl lg:text-[35px] tracking-[1px] sm:tracking-[2px] font-semibold text-white font-poppins leading-none sm:leading-tight sm:pb-2 md:pb-4 lg:pb-6 text-left">
                {t("DownloadApp")} <br className="xs:block" />
                <span className="sm:mt-[12px]  mb-4 sm:mb-8 inline-block">
                  {t("DownloadApp2")}
                </span>
              </h2>
              <p className="text-white text-[10px] sm:text-sm md:text-base lg:text-xl font-medium font-poppins leading-none sm:leading-normal text-left">
                {t("DownloadAppDesc")} <br className="block sm:hidden" />
                <span className="mt-[5px] sm:mt-0 sm:ml-1 inline-block">
                  {t("DownloadAppDesc2")}
                </span>
                <br className="sm:block" />
                <span className="mt-[6px] inline-block">
                  {t("DownloadAppDesc3")}
                </span>
              </p>
              <div className="flex flex-row items-center gap-2 sm:gap-3 md:gap-4 pt-2 sm:pt-3 md:pt-4">
                <a
                  href="https://apps.apple.com/app/qriend"
                  className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                >
                  <img
                    src="/assets/appStore.svg"
                    alt="App Store'dan İndir"
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.qriend"
                  className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                >
                  <img
                    src="/assets/googlePlay.svg"
                    alt="Google Play'den İndir"
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Footer */}
      <Footer isHomePage={true} />
    </div>
  );
}
